<ng-container *transloco="let tloco; prefix: 'subscriptions.billing-details'">
  <form [formGroup]="form" (ngSubmit)="onSubmit(form.value, form.valid)">
    <h1 class="text-heading-2" mat-dialog-title>{{ tloco('model-title') }}</h1>
    <mat-dialog-content>
      <div class="mb-3">{{ tloco('model-subtitle') }}</div>
      <mat-form-field class="w-full" appearance="outline">
        <mat-label>{{ tloco('email.label') }}</mat-label>
        <input type="email" [placeholder]="tloco('email.placeholder')" matInput formControlName="email" required />
        <mat-error />
      </mat-form-field>
      @if (error$ | async; as error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button type="button" mat-button color="primary" mat-dialog-close>
        {{ tloco('cancel') }}
      </button>
      <button type="submit" mat-flat-button color="primary">
        {{ tloco('save') }}
      </button>
    </mat-dialog-actions>

    <button type="button" class="top-modal-close" mat-dialog-close>
      <rma-icon glyph="close" />
    </button>
  </form>
</ng-container>
